import { Link } from 'react-router-dom';

import { type StackType } from '@/lib/prompt-lib-utils';
import { cn } from '@/lib/utils';

interface PromptCardProps {
  id: string;
  title: string;
  description: string;
  stackType: StackType;
  className?: string;
  isMobile?: boolean;
}

export function PromptCard({
  id,
  title,
  description,
  stackType,
  className,
  isMobile,
}: PromptCardProps) {
  return (
    <Link
      to={`/dashboard/prompt-library/${id}`}
      className={cn(
        'group flex flex-col rounded-2xl border border-border bg-card',
        'transition-all duration-150 hover:border-foreground/20 hover:shadow-sm',
        isMobile ? 'p-4' : 'p-5',
        className
      )}
    >
      <div className="flex items-start justify-between gap-3 mb-1.5">
        <h3 className="font-semibold text-sm text-foreground leading-snug">
          {title}
        </h3>
        <span className="shrink-0 mt-0.5 rounded-full bg-muted px-2 py-0.5 text-[10px] font-medium text-muted-foreground">
          {stackType === 'fullstack' ? 'Fullstack' : 'Frontend'}
        </span>
      </div>
      <p className="text-xs text-muted-foreground line-clamp-2 leading-relaxed">{description}</p>
    </Link>
  );
}
